import { render, staticRenderFns } from "./LinkEditUser.vue?vue&type=template&id=6a252ed0&scoped=true&"
import script from "./LinkEditUser.vue?vue&type=script&lang=js&"
export * from "./LinkEditUser.vue?vue&type=script&lang=js&"
import style0 from "./LinkEditUser.vue?vue&type=style&index=0&id=6a252ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a252ed0",
  null
  
)

export default component.exports